import React, { useState } from 'react';
import { Tr, Td } from 'react-super-responsive-table';

import PropTypes from 'prop-types';
import {
    Menu,
    Box,
} from '@mui/material';

import {
    CreateFilter,
} from '../../Common';

const RowHeaderFilter = ({
    children,
    getColumn,
    handleFilterKeyUp,
    handleFilterClick,
    filterProps
}) => {

    const [filterOptionAnchor, setFilterOptionAnchor] = useState(null);
    const [createFilterProps, setCreateFilterProps] = useState({
        type: 'text'
    });

    const onHandleClick = (e, col) => {

        const {
            filter, property, initialValue
        } = col;

        if (filter && (filter.toLowerCase() === "date" || filter.toLowerCase() === "range")) {
            setCreateFilterProps({
                type: filter,
                property,
                initialValue,
                applyFunction: (value) => {
                    handleFilterKeyUp({
                        keyCode: 13,
                        target: {
                            id: property,
                            value: value
                        }
                    })
                }
            })
            setFilterOptionAnchor(e.currentTarget);
            return;
        }

        handleFilterClick(e);
    }

    const onHandleKeyUp = (e, filter) => {
        if (filter && filter.toLowerCase() === "date") {
            return;
        }

        handleFilterKeyUp(e);
    }

    return (
        <>
            <Tr className="table-columnheaderfilter">
                {children.map(column => (
                    (column.props.property && (
                        <Td
                            className={((getColumn(column.props.property)).visible === false ? ' hideColumn' : '')}
                            width={column.props.width}
                        >
                            {(column.props.property && column.props.filter && !column.props.filterDisabled) && (
                                <input
                                    type="text"
                                    id={column.props.property}
                                    onKeyUp={(e) => onHandleKeyUp(e, column.props.filter)}
                                    onClick={(e) => onHandleClick(e, column.props)}
                                    autoComplete="false"
                                    placeholder="Filter"
                                    style={{
                                        width: "100%"
                                    }}
                                />
                            )}
                        </Td>
                    ))
                ))}
            </Tr>

            <Menu
                anchorEl={filterOptionAnchor}
                open={Boolean(filterOptionAnchor)}
                PaperProps={{
                    style: {
                        width: createFilterProps.type === "date" ? 400 : 300,
                        height: 'auto',
                        maxHeight: '50vh',
                        overflow: 'visible'
                    }
                }}
                onClose={() => {
                    setFilterOptionAnchor(null);
                    setCreateFilterProps({
                        type: 'text'
                    });
                }}
            >
                <Box sx={{ p: 2, width: createFilterProps.type === "date" ? 400 : 300 }}>
                    {
                        createFilterProps && (
                            <CreateFilter
                                {...createFilterProps}
                                filterValues={[]}
                                filterProps={filterProps}
                                disableDatePickerPortal={true}
                            />
                        )
                    }
                </Box>
            </Menu>
        </>
    )
}

RowHeaderFilter.propTypes = {
    children: PropTypes.object.isRequired,
    getColumn: PropTypes.func.isRequired,
    handleFilterKeyUp: PropTypes.func.isRequired,
    handleFilterClick: PropTypes.func.isRequired
};

export default RowHeaderFilter;